export function MissionModel(dict) {
    this.name = dict.Name;
    this.partitionKey = dict.PartitionKey;
    this.period = dict.Period;
    this.points = dict.Points;
    this.customInfo = dict.CustomInfo;
    this.description = dict.Description;
    this.rowKey = dict.RowKey;
    this.sequence = dict.Sequence;
    this.userLevel = dict.UserLevel;
    this.missions = dict.Missions;
    this.condition = dict.FBDescription;


    this.setDataFromApi = function (data) {
        this.name = data.Name;
        this.partitionKey = data.PartitionKey;
        this.period = data.Period;
        this.points = data.Points;
        this.customInfo = data.CustomInfo;
        this.description = data.Description;
        this.rowKey = data.RowKey;
        this.sequence = data.Sequence;
        this.userLevel = data.UserLevel;
        this.missions = data.Missions;
    }
}
